/**
 * Product Description Read More Functionality
 */
class ProductDescription {
  constructor() {
    this.descriptions = document.querySelectorAll('.product__description');
    this.init();
    
    // Check again after images and other content might have loaded
    window.addEventListener('load', () => this.init());
    
    // Also check after a short delay to catch any dynamic content
    setTimeout(() => this.init(), 500);
  }

  init() {
    this.descriptions.forEach(description => {
      const content = description.querySelector('.product__description-content');
      const button = description.querySelector('.product__description-button');
      const gradient = description.querySelector('.product__description-gradient');
      
      if (!content || !button) return;
      
      // Set a unique ID for the content if it doesn't have one
      if (!content.id) {
        const uniqueId = `ProductDescriptionContent-${Math.random().toString(36).substring(2, 9)}`;
        content.id = uniqueId;
        button.setAttribute('aria-controls', uniqueId);
      }
      
      // Only show the read more button if the content is taller than the max-height
      if (content.scrollHeight > 150) {
        button.style.display = 'block';
        if (gradient) gradient.style.display = 'block';
        
        // Only add the event listener once
        if (!button.hasAttribute('data-initialized')) {
          button.setAttribute('data-initialized', 'true');
          button.addEventListener('click', () => {
            const expanded = description.classList.contains('expanded');
            description.classList.toggle('expanded');
            button.setAttribute('aria-expanded', !expanded);
          });
        }
      } else {
        // Hide the button and gradient if there's not enough content
        button.style.display = 'none';
        if (gradient) gradient.style.display = 'none';
      }
    });
  }
}

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', () => {
  new ProductDescription();
});

// Re-initialize when the section is reloaded by Shopify
document.addEventListener('shopify:section:load', (event) => {
  if (event.detail.sectionId.includes('main-product')) {
    new ProductDescription();
  }
}); 